module.exports = __webpack_public_path__ + "assets/img/mecha-btn-98180d20.png";